import {useState} from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Card } from "@mui/material";
import TechResultsPane from './TechResultsPane';
import TechFilterPane from './TechFilterPane';
import TechStatBanner from './TechStatBanner';
import ProviderPopover from './ProviderPopover';

const theme = createTheme({
  typography: {
    fontFamily: ["Radio Canada Big", "Arial"].join(",")
  }
});

const backgroundColor = '#ffffff';

function TechDirectory(props) {
    const [ refreshList, setRefreshList ] = useState(false);
    const [activeResult, setActiveResult] = useState(null);
    const [ techProviders, setTechProviders ] = useState([]);
    const [ filteredTechProviders, setFilteredTechProviders ] = useState([]);

    const selectedResult = (result) => {
      setActiveResult(result);
  }

  return (
<ThemeProvider theme={theme}>
    <Box sx={{ flexGrow: 1 }}>
        <Box size={8} sx={{ backgroundColor: {backgroundColor}, padding: '20px'}}>
          <TechStatBanner {...props} {...{techProviders, setTechProviders}} />
        </Box>
        <Box sx={{height:'35px', display: 'flex', alignItems: 'flex-end', float: 'right'}}>
          <Tooltip title="Site Powered By">
            <img width="35px" src="dev.png" alt="Site Powered By" />
          </Tooltip>
        </Box>

        <Box sx={{ backgroundColor: {backgroundColor}, marginBottom: '2em', width: '95%', marginLeft: 'auto', marginRight: 'auto'}}>
          <TechFilterPane {...{techProviders, setTechProviders, filteredTechProviders, setFilteredTechProviders}}/>
        </Box>

        <Card sx={{backgroundColor: '#f1f1f1', width: '95%', marginLeft: 'auto', marginRight: 'auto'}}>
          <TechResultsPane {...props} {...{refreshList, setRefreshList, techProviders, setTechProviders, filteredTechProviders, setFilteredTechProviders}} onSelectResult={selectedResult} />
        </Card>
    </Box>
    <ProviderPopover {...{ activeResult, setActiveResult, techProviders }} />
</ThemeProvider>
  );
}

export default TechDirectory;
